export const round = precision => num => {
  const pow = Math.pow(10, precision);
  return Math.round(num * pow) / pow;
};
